import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Parcel, PropertyUseCode } from './research.types';
import { Store } from '@ngxs/store';
import { Research } from './state/actions';
import { ResearchState } from './state/state';

@Injectable({
  providedIn: 'root',
})
export class ResearchDataResolver {
  constructor(private readonly store: Store) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<{ property_use_codes: PropertyUseCode[] }> {
    return this.store.dispatch(new Research.SetPropertyUseCodes()).pipe(
      map(() => ({
        property_use_codes: this.store.selectSnapshot(ResearchState.propertyUseCodes),
      })),
    );
  }
}

@Injectable({ providedIn: 'root' })
export class ResearchParcelResolver {
  constructor(private readonly store: Store) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Parcel> {
    return this.store
      .dispatch(new Research.GetAndSelectParcel(route.paramMap.get('id'), 'all'))
      .pipe(map(() => this.store.selectSnapshot(ResearchState.selectedParcel)));
  }
}
